import React, { useState } from 'react';
import { DefinedRange } from 'react-date-range';

interface SafeDefinedRangeProps {
  ranges: any[];
  onChange: (item: any) => void;
  staticRanges: any[];
  renderStaticRangeLabel?: (range: any) => React.ReactNode;
  [key: string]: any;
}

const SafeDefinedRange: React.FC<SafeDefinedRangeProps> = ({
  ranges,
  onChange,
  staticRanges,
  renderStaticRangeLabel,
  ...rest
}) => {
  const [error, setError] = useState<string | null>(null);

  const handleChange = (item: any) => {
    try {
      // Ensure the item has the required properties
      if (item && item.selection) {
        onChange(item);
      }
    } catch (err) {
      console.error('Error in SafeDefinedRange handleChange:', err);
      setError('Date range selection error occurred');
    }
  };

  if (error) {
    return (
      <div className="alert alert-danger">
        <strong>Error:</strong> {error}
        <button
          className="btn btn-sm btn-outline-danger ms-2"
          onClick={() => setError(null)}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="rdrDateRangeWrapper">
      <DefinedRange
        ranges={ranges}
        onChange={handleChange}
        staticRanges={staticRanges}
        renderStaticRangeLabel={renderStaticRangeLabel}
        {...rest}
      />
    </div>
  );
};

export default SafeDefinedRange; 